import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import {
    StandardPaymentMethods,
    getStandardPaymentMethodProps,
} from "@qgiv/core-donor";
import { useFormikContext } from "formik";
import ConnectedBankFields from "./ConnectedBankFields";
import ConnectedPaymentIframe from "./ConnectedPaymentIframe";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedStandardPaymentMethods = ({ controlId }) => {
    const {
        ENUMS: { DefaultView, PaymentType },
    } = constants;
    const formikContext = useFormikContext();
    const { values } = formikContext;
    const { Payment_Type } = values;
    const formSettings = useSelector(selectAllFormSettings);
    const {
        enableAchPayments = false,
        enableCCPayments = false,
        enablePaypalPayments = false,
    } = formSettings;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );

    const {
        options: { creditCard, echeck },
    } = control;
    const acceptedPayments = [];
    const creditTab = <ConnectedPaymentIframe controlId={controlId} />;
    const creditTabLabel = creditCard.tabLabel;
    const echeckTab = <ConnectedBankFields controlId={controlId} />;
    const echeckTabLabel = echeck.tabLabel;

    if (enableCCPayments) {
        acceptedPayments.push({
            label: creditTabLabel,
            content: creditTab,
            active: Payment_Type === PaymentType.CREDITCARD,
            id: "credit-tab",
        });
    }

    if (enableAchPayments) {
        acceptedPayments.push({
            label: echeckTabLabel,
            content: echeckTab,
            active: Payment_Type === PaymentType.ECHECK,
            id: "echeck-tab",
        });
    }

    // Accounts have not been set up on the redesigned P2P form. Because of
    // that users cannot view saved payment methods here and the invoice
    // button will never be displayed.
    const hasToggledPaymentMethodView = false;
    const registrationDetails = {};
    // Assemble the payment data into an object that resembles the payment data
    // object that is present in formSettings in events
    const paymentData = {
        enableAchPayments,
        enableCCPayments,
        enablePaypalPayments,
    };

    const standardPaymentMethodPropsOptions = {
        acceptedPayments,
        control,
        formikContext,
        formSettings,
        hasToggledPaymentMethodView,
        registrationDetails,
        paymentData,
    };
    const standardPaymentMethodProps = getStandardPaymentMethodProps(
        standardPaymentMethodPropsOptions,
    );

    return <StandardPaymentMethods {...standardPaymentMethodProps} />;
};

ConnectedStandardPaymentMethods.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedStandardPaymentMethods;
